<!-- 알림 아이콘 클릭시 호출되는 패널 -->
<script setup>
import { useAxios } from '@/hooks/useAxios';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const isVisible = ref(false);
const isMorePanelVisible = ref(false);
const alarmComponentRef = ref(null);

defineProps(['class']);

const searchParam = ref(null);
const rowData = ref([]);

const urlPost = ref('');
const apiType = ref('');

const notifications = computed(() => rowData.value);
const readState = ref(false);
// const notifications = ref([
//     { title: '제목 1제목 1제목 1제목 1제목 1제목 1', message: '알림 1 길이 테스트 중 글자 수 테스트 글자 수 테스트', read: false, id: 1 },
//     { title: '제목 2', message: '알림 2 길이 테스트 중 글자 수 테스트 글자 수 테스트', read: true, id: 2 },
//     { title: '제목 3', message: '알림 3', read: false, id: 3 },
//     { title: '제목 4', message: '알림 4', read: false, id: 4 },
//     { title: '제목 5', message: '알림 5', read: false, id: 5 },
//     { title: '제목 6', message: '알림 6', read: false, id: 6 },
//     { title: '제목 7', message: '알림 7', read: false, id: 7 },
//     { title: '제목 8', message: '알림 8', read: false, id: 8 },
//     { title: '제목 9', message: '알림 9 길이 테스트 중 글자 수 테스트', read: false, id: 9 },
//     { title: '제목 10', message: '알림 10', read: false, id: 10 },
//     { title: '제목 11', message: '알림 11', read: false, id: 11 },
//     { title: '제목 12', message: '알림 12', read: false, id: 12 }
// ]);

const currentTab = ref('unread');
const getFilteredNotifications = () => {
    //console.log(notifications.value);
    //console.log(rowData.value);
    let nonRead = notifications.value.some((s) => s.read_yn === 'N');
    //console.log(nonRead);

    readState.value = nonRead;
    return notifications.value;
    // return currentTab.value === 'unread' ? notifications.value.filter((n) => !n.read) : notifications.value.filter((n) => n.read);
};

const closePopup = () => {
    isVisible.value = false;
    unbindOutsideClickListener();
    search();
};

const openPopup = () => {
    isVisible.value = true;
    bindOutsideClickListener();
    search();
};

const bindOutsideClickListener = () => {
    document.addEventListener('click', outsideClickListener);
};

const unbindOutsideClickListener = () => {
    document.removeEventListener('click', outsideClickListener);
};

const outsideClickListener = (event) => {
    const panel = alarmComponentRef.value;
    const actionButtons = document.querySelectorAll('.action-button');
    if (panel && !panel.contains(event.target) && ![...actionButtons].some((btn) => btn.contains(event.target))) {
        closePopup();
    }
};

onMounted(() => {
    search();
});

onBeforeUnmount(() => {
    unbindOutsideClickListener();
});

const search = () => {
    rowData.value = [];

    const url = '/api/notification';
    let query = searchParam.value;
    const config = {
        method: 'get',
        params: query
    };
    const { data, error, execute } = useAxios(url, config, {
        onSuccess(response) {
            rowData.value = response.data.data;

            let unreadCount = response.data.data.reduce((count, s) => {
                return s.read_yn === 'N' ? count + 1 : count;
            }, 0);
            readState.value = unreadCount;
        },
        onError(err) {
            console.error('Error:', err.message);
        }
    });
};

const handleMessageClick = (id) => {
    router.push({ name: 'notificationDetail', params: { id } });
};

const viewMore = () => {
    router.push({ name: 'allNotifications' });
};

const viewMoreModal = () => {
    search();
    closePopup();
    if (isMorePanelVisible.value) {
        isMorePanelVisible.value = false;
    } else {
        isMorePanelVisible.value = true;
    }
};

const markAllAsRead = () => {
    notifications.value.forEach((notification) => (notification.read = true));
    currentTab.value = 'read';
};

const forceNavigate = async (routeName, queryData) => {
    const currentRoute = router.currentRoute.value;

    if (currentRoute.name === routeName) {
        await router.push('/').catch(() => {});
        await router.push({ name: routeName, query: queryData });
    } else {
        await router.push({ name: routeName, query: queryData });
    }
};

const onDetailSearch = async (event) => {
    let eventId = event['id'];
    apiType.value = 'POST';
    urlPost.value = `/api/notification/${eventId}`;
    execute('', '', false)
        .then((isSuccess) => {
            //console.log(isSuccess);
            if (isSuccess.success) {
            }
        })
        .catch((isFailure) => {
            //console.log(isFailure);
            if (!isFailure.success) {
            }
        });

    let queryData = {};
    queryData['type'] = 'eventAlaram';
    queryData['action_key'] = event.action_key;
    queryData['reservation_no'] = event.action_value;
    queryData['untact_contract_id'] = event.action_value;
    queryData['contract_no'] = event.action_value2;
    queryData['contract_type'] = event.action_value3;

    const key = event.action_key;

    if (key === 'INSP' || key === 'NOSP' || key === 'RESV' || key === 'RECN') {
        await forceNavigate('contract_reservation', queryData);
    } else if (key === 'INSU') {
        queryData['type'] = 'event';
        router.push({ name: 'contract_insurance', query: queryData });
    } else if (key === 'NOML') {
        queryData['type'] = 'event';
        router.push({ name: 'contract_nomal', query: queryData });
    } else {
        router.push({ name: 'schedule', query: queryData });
    }

    closePopup();
    isMorePanelVisible.value = false;
};

const execute = (body) => {
    const config = {
        method: apiType.value || 'post',
        params: {}
    };

    return new Promise((resolve, reject) => {
        let callApi = useAxios(urlPost.value, config, {
            immediate: false,
            onSuccess(response) {
                resolve({
                    success: true,
                    message: 'API 호출에 성공.',
                    details: response
                });
            },
            onError(response) {
                //console.log(response);

                reject({
                    success: false,
                    message: 'API 호출에 실패했습니다.',
                    details: response
                });
            }
        }).execute(body);
        return callApi;
    });
};

defineExpose({
    openPopup,
    closePopup,
    isVisible,
    readState
});
</script>

<template>
    <div ref="alarmComponentRef" class="alarm-popup select-none" v-if="isVisible">
        <div class="alarm-popup-header">
            <h3 class="alarm-title">모든 알림</h3>
        </div>
        <div class="alarm-content">
            <ul>
                <li v-if="getFilteredNotifications().length === 0">알림이 없습니다.</li>
                <li v-for="notification in getFilteredNotifications()" @click="onDetailSearch(notification)" :key="notification.id" class="notification-item">
                    <!--<i class="pi pi-hashtag notification-icon"></i>-->
                    <div class="flex items-center w-full">
                        <div>
                            <div v-if="notification.action_key === 'NOSP' || notification.action_key === 'NOML'">
                                <span class="NOML">일반 </span>
                            </div>
                            <div v-else-if="notification.action_key === 'INSU' || notification.action_key === 'INSP'">
                                <span class="INSP">보험 </span>
                            </div>
                            <div v-else>
                                <span class="ELSE">배차 </span>
                            </div>
                        </div>

                        <div class="w-full ml-1">
                            <div class="flex items-center w-full">
                                <div class="notification-title" :title="notification.body">
                                    {{ notification.title.length > 20 ? notification.title.slice(0, 20) + '...' : notification.title }}
                                    <sup v-if="notification.read_yn === 'N'" class="badge_new bounceIn animated">new</sup>
                                </div>
                                <div class="notification-body !text-right !text-[#a5a7ac]" :title="notification.body">
                                    <!-- {{ notification.body.length > 29 ? notification.body.slice(0, 29) + '...' : notification.body }} -->
                                    {{ notification.create_date }}
                                </div>
                            </div>
                            <div class="text-[#888a8f] text-[0.875rem]">
                                <p>{{ notification.body.length > 29 ? notification.body.slice(0, 29) + '...' : notification.body }}</p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- <div class="view-more-container">
                <button @click="viewMoreModal" class="view-more-button">더 보기</button>
            </div> -->
        </div>
    </div>
    <DefaultPanel v-if="isMorePanelVisible" :title="'전체 알림 보기'" width="35rem" height="40rem" @close="viewMoreModal">
        <ul>
            <li v-for="notification in getFilteredNotifications()" :key="notification.id" class="notification-item !block cursor-pointer !py-3" @click="onDetailSearch(notification)">
                <div class="flex items-center w-full">
                    <div>
                        <div v-if="notification.action_key === 'NOSP' || notification.action_key === 'NOML'">
                            <span class="NOML">일반 </span>
                        </div>
                        <div v-else-if="notification.action_key === 'INSU' || notification.action_key === 'INSP'">
                            <span class="INSP">보험 </span>
                        </div>
                        <div v-else>
                            <span class="ELSE">배차 </span>
                        </div>
                    </div>

                    <div class="w-full ml-1">
                        <div class="flex items-center w-full">
                            <div class="notification-title" :title="notification.title">
                                {{ notification.title.length > 20 ? notification.title.slice(0, 20) + '...' : notification.title }}
                            </div>
                            <div class="notification-body !text-right !text-[#a5a7ac]" :title="notification.body">
                                <!-- {{ notification.body.length > 29 ? notification.body.slice(0, 29) + '...' : notification.body }} -->
                                {{ notification.create_date }}
                                <sup v-if="notification.read_yn === 'N'" class="badge_new bounceIn animated">new</sup>
                            </div>
                        </div>
                        <div class="text-[#888a8f] text-[0.875rem]">
                            <p>{{ notification.body.length > 29 ? notification.body.slice(0, 29) + '...' : notification.body }}</p>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </DefaultPanel>
</template>
<style scoped>
.alarm-popup {
    position: absolute;
    top: 3.5rem;
    right: 3.6rem;
    width: 35rem;
    height: 38.4rem;
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 3rem 1.8rem 1.8rem 1.8rem;
    z-index: 300;
    overflow-y: auto;
}

.alarm-popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
}

.alarm-title {
    font-size: 1rem;
    font-weight: bold;
}

.mark-all-read-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    color: #0038ea;
}

.mark-all-read-button:hover {
    font-weight: bold;
}

.alarm-tabs {
    display: flex;
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd;
}

.alarm-tabs button {
    background: none;
    padding: 0.5rem 1.2rem;
    cursor: pointer;
    border-radius: 4px 4px 0 0;
    font-size: 0.9rem;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;
}

.active-tab {
    font-weight: bold;
    color: #0038ea;
    border-bottom: 0.25rem solid #0038ea;
}

.alarm-content ul {
    list-style: none;
    padding: 0;
    width: 100%;
}

.notification-item {
    display: flex;
    align-items: center;
    padding: 0.6rem 1rem;
    background-color: white;
    border: 1px solid #d4dbe4;
    margin-bottom: 0.6rem;
    border-radius: 0.4rem;
    cursor: pointer;
}

.notification-item:hover {
    box-shadow: 0px 4px 4px rgb(0, 0, 0, 0.05);
    border: 1px solid #0038ea;
}

.notification-icon {
    margin-right: 0.6rem;
    font-size: 0.9rem; /* Adjust icon size as needed */
    background-color: #b3b3b3;
    padding: 0.6rem;
    border-radius: 0.3rem;
    color: white;
}

.notification-text {
    display: flex;
    flex-direction: column;
}

.notification-title {
    font-weight: bold;
    margin-bottom: 0.1rem;
    font-size: 0.875rem;
    background: none;
    border: none;
    text-align: left;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #35424a;
}

.view-more-title {
    border: none;
    cursor: pointer;
    font-size: 0.6rem;
    color: #555;
    margin-left: 12rem;
    margin-bottom: 0.1rem;
}

.notification-body {
    font-size: 0.725rem;
    color: #888a8f;
    background: none;
    border: none;
    text-align: left;
    width: 100%;
}

/* .view-more-container {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    text-align: right;
} */

.view-more-container {
    width: 100%;
}

.view-more-button {
    width: 100%;
    text-align: center;
    color: #888a8f;
    font-size: 0.8rem;
    /* font-weight: bold; */
    /* border: 1px solid #d1d5db; */
    padding: 0.4rem;
    margin-top: 2rem;
    cursor: pointer;
    transition: border-color 0.3s ease;
}

.view-more-button:hover {
    /* border-color: #0038ea; */
    color: #0038ea;
    font-weight: bold;
}
@keyframes bounceIn {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }
    50% {
        opacity: 1;
        transform: scale(1.05);
    }
    70% {
        transform: scale(0.9);
    }
    100% {
        transform: scale(1);
    }
}

.badge_new {
    display: inline-block;
    min-width: 10px;
    font-size: 0.6rem;
    color: #ff1d6c;
    line-height: 1;
    vertical-align: middle;
    white-space: nowrap;
}
.NOML {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background-color: #e8f0fe;
    color: #0038ea;
    font-size: 0.75rem;
    border-radius: 50%;
    text-align: center;
    margin-right: 5px;
}
.INSP {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background-color: #ffa764;
    color: white;
    font-size: 0.75rem;
    border-radius: 50%;
    text-align: center;
    margin-right: 5px;
}
.ELSE {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background-color: #6eb79a;
    color: white;
    font-size: 0.75rem;
    border-radius: 50%;
    text-align: center;
    margin-right: 5px;
}
</style>
